export default "__VITE_ASSET__ce2f101c__"